// Product Section Initialization
// Handles product section initialization, nice-select, and Firebase integration

export function initializeProductSection(
    container?: HTMLElement | null,
    sortSelect?: HTMLSelectElement | null,
    language?: string
): void {
    const jQuery = (window as any).jQuery;
    if (typeof jQuery === 'undefined') {
        // Retry if jQuery not loaded yet
        setTimeout(() => initializeProductSection(container, sortSelect, language), 500);
        return;
    }

    try {
        // Initialize nice-select for sort dropdown
        if (sortSelect && typeof jQuery.fn.niceSelect !== 'undefined') {
            const $select = jQuery(sortSelect);
            const niceSelectWrapper = $select.next('.nice-select');
            
            if (niceSelectWrapper.length > 0) {
                $select.niceSelect('destroy');
            }
            
            setTimeout(() => {
                $select.niceSelect();
            }, 50);
        }

        // Initialize tab switching
        if (container) {
            const tabButtons = container.querySelectorAll('.tab-btn-item');
            const tabContents = container.querySelectorAll('.tab-content-box-item');

            tabButtons.forEach(button => {
                button.addEventListener('click', function(this: HTMLElement) {
                    const targetTab = this.getAttribute('data-tab');
                    
                    // Remove active classes
                    tabButtons.forEach(btn => btn.classList.remove('active-btn-item'));
                    tabContents.forEach(content => content.classList.remove('tab-content-box-item-active'));
                    
                    // Add active classes
                    this.classList.add('active-btn-item');
                    const targetContent = container.querySelector(targetTab || '');
                    if (targetContent) {
                        targetContent.classList.add('tab-content-box-item-active');
                    }
                });
            });
        }

    } catch (error) {
    }
}

// Expose function globally for use in other scripts
if (typeof window !== 'undefined') {
    (window as any).initializeProductSection = initializeProductSection;
}

